module.exports = __webpack_public_path__ + "img/shop5_1.b01d22e5.png";